import "./About.css";
const About = () => {
    return ( 
        <>
            <div className="intro">
                Amahle-amashenge Holdings (Pty) Ltd is a local conglomerate entity, which has interest in diverse industries. Amahle-Amashenge Holdings (Pty) Ltd is made up of a group of local youth with tacit and explict skills.
            </div>
            <div className="team">
                <h1>Leadership Group</h1>
                <div>
                    <h3>MLU BUTHELEZI</h3>
                    <p>FONDER/ CEO</p>
                </div>
                <div>
                    <h3>NHLANHLA SONQUSHU</h3>
                    <p>COO/ SHEQ DIRECTOR</p>
                </div>
                <div>
                    <h3>LUCKY NYENBE</h3>
                    <p>DIRECTOR</p>
                </div>
            </div> 
            <h1 className="heading">Our Values</h1>
            <div className="values">
                <div className="strength">
                    <h2>Strength</h2>
                    <p>We are a solid partner for our customers and all stakeholders based on the integrity and competency of our people, our years of experience, and our track record for delivering results.</p>
                </div>
                <div className="passion">
                    <h2>Passion</h2>
                    <p>We care about and we are personally committed to everything we do, especially our people and their safety and development, our customers and their success, and the world we inhabit, in particular the people and environment in the communities where we live and work</p>
                </div>
                <div className="performance">
                    <h2>Performance</h2>
                    <p>We demand excellence, deliver on our promises and continuously search for new and better ways to provide the best solutions for our customers and all stakeholders</p>
                </div>
            </div>
            <div className="seperator">
            </div>
            <div className="values">
                <div className="strength">
                    <h2>Safety, Health and Environment Management</h2>
                    <p>Amahle-amashenge Holdings (PTY) Ltd Safety, health and environment (SHE) policy and practices Centres around a zero-harm philosophy towards people, host communities and the environment. Although the group operates in provinces with differing governance standards, it consistently enforces a standard approach to SHE and does not compromise its standards of conduct when operating in all provinces.
                    </p>
                </div>
                <div className="strength">
                    <h2>BEE</h2>
                    <p>Amahle-amashenge Holdings (Pty) Ltd is 100% black-owned and proud to be a BEE company. We are committed to promoting BEE across all levels of our organization. We strive to ensure that Amahle-amashenge Holdings (Pty) Ltd is a good corporate citizen through our social and enterprise development initiatives as well as complying with all legislation in terms of BEE.</p>
                </div>
            </div>
            <div className="seperator second">
            </div>

            <h1 className="heading">Accreditations</h1>
            <div className="creditation">
                
                <div className="list">
                    <ul>
                        <li>CIDB NO : 10264167</li>
                        <li>CIDB Grading: 3CE PE. 3SH PE. 2SK PE </li>
                        <li>CSD : MAAA0507165</li>
                        <li>SHEQ : SAMTRAC</li>
                        <li>Bbbee : level 1</li>
                        <li>Electrical Safety(SAQA Unit St No 258925)</li>
                        <li>Electrical Access (0 RH V s) SAQA Unit St No 242766</li>
                        <li>COIDA : 990001269388</li>
                        <li>PAYE : 7860812231</li>
                        <li>UIF : U860812231</li>
                        
                    </ul>
                </div>
            </div>



        </>
     );
}
 
export default About;